import { Cookie as SetCookieOutput } from 'set-cookie-parser';
import { AuthChallenge } from './AuthChallenge';
import { BaseTableEntry } from 'src/auth/TypeDefinitions';

interface TokenString {
	token: string;
}

export interface SecondaryTokenResponse {
	status: number; //integerConstants.TOKEN_RECEIVED or TOKEN_NOT_RECEIVED
	details: TokenString | RequestTokenFailureResponse;
}

export interface RequestTokenFailureResponse {
	errorCode: number;
	errorMessage: string;
}

export interface HTTPFetchResponse {
	statusCode: number;
	body: string;
	headers: HeadersJson;
}

export interface SecondaryTokenTableEntry extends BaseTableEntry {
	tokenForService: string;
	tokenIssuedDate: Date;
	tokenExpiryDate: Date;
	tokenLifeTime: string;
	token: string;
	tokenExpiryMillis: number;
	authDomain: string;
	serviceURL: string;
}

export interface PrimaryTokenTableEntry extends BaseTableEntry {
	authDomain: string;
	tokenForService: string;
	tokenIssuedDate: string;
	tokenExpiryDate: Date;
	tokenLifeTime: string;
	token: string;
	tokenExpiryMillis: number;
	serviceURL: string;
	webLogoffUrl: string | null;
}

export interface DomainCookieTableEntry extends BaseTableEntry {
	domain: string;
	cookie: Cookie[];
}

export interface ResponseToNative {
	id: string;
	URLResponse: HTTPFetchResponse;
	token: string;
	errorCode: number;
	errorMessage: string;
}

export interface SecondaryTokenResponseToNative {
	id: string;
	token: string;
	errorCode: number;
	errorMessage: string;
}
export interface ConstructAMLResponseFunctionType {
	id: string;
	URLResponse?: HTTPFetchResponse;
	token?: string;
	errorCode?: number;
	errorMessage?: string;
}

export interface ConstructAMLSecondaryTokenResponseFunctionParams {
	id: string;
	token?: string;
	errorCode?: number;
	errorMessage?: string;
}
export interface StoreSecondaryTokenFunctionParams {
	referenceUri: string;
	url: string;
	authDomain: string;
	authChallenge: AuthChallenge;
	id: string;
}

export interface CookieLookUpParams {
	readonly domain: string;
	readonly isForSubdomain: boolean;
	readonly path: string;
	readonly isHTTPS: boolean;
	readonly referenceUri: string;
}

export interface RequestParams {
	readonly id: string;
	readonly authType: string;
	readonly method: string;
	readonly url: string;
	readonly referenceUri: string;
	body: string;
	allowCredUi?: boolean;
	allowSilentLogin?: boolean;
	returnSecondaryToken?: boolean;
	authDomain?: string;
	headers?: HeadersJson;
}

export interface HeadersJson {
	[key: string]: string;
}

export interface RequestTokenChoicesJson {
	requesttokenchoices: {
		choices: {
			choice: AuthChoiceJson | AuthChoiceJson[];
		};
	};
}

export interface AuthChoiceJson {
	readonly protocol: string;
	readonly location: string;
}

export interface Cookie extends SetCookieOutput {
	cookieExpiryMillis?: number;
}

export interface AuthResponseWithToken {
	authResponse: HTTPFetchResponse;
	tokenObj: SecondaryTokenTableEntry;
}
export class QueuedRequest {
	readonly id: string;
	readonly referenceUri: string;
	webviewResolve: Function;
	waitStatusResolve: Function;
	reject: Function;

	constructor(id: string, referenceUri: string) {
		this.id = id;
		this.referenceUri = referenceUri;
	}
}

export class PrimaryTokenStatus {
	status: string;
	shouldClearQueue: boolean;

	constructor(status: string, shouldClearQueue: boolean) {
		this.status = status;
		this.shouldClearQueue = shouldClearQueue;
	}
}

export interface GenericRequest {
	readonly method: string;
	readonly headers: HeadersJson;
	readonly body: string;
	readonly url: string;
}

export enum AuthenticationMode {
	DSAuth,
	OIDC,
}

export type ProtectionMode = 'ProtectMemory' | 'ProtectData';

export enum SsoCredentialType {
	UserNameDomain,
	SmartCard,
}

export interface UserNameDomainCredentials {
	domain?: string;
	userName: string;
	password: string;
}
